module.exports = __webpack_public_path__ + "static/img/level2.2ee15630.png";